(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("SettingsViewModel", settingsViewModelFactory);

  /** @ngInject */
  function settingsViewModelFactory(
    deviceActions,
    modelUtils,
    facilityUtils,
    washBoxUtils,
    tapWaterSubsystemUtils,
    reverseOsmosisSubsystemUtils,
    demiWaterSubsystemUtils,
    softenedWaterSubsystemUtils,
    doserSubsystemUtils,
    ModBusTypeEnum
  ) {
    function SettingsViewModel(deviceSerial) {
      this.deviceSerial = deviceSerial;
      this.lightsAuto = false;
      this.lightsOn = false;
      this.boxes = [];
      this.modbusType = "";
      this.noDecimals = '^[0-9]+[0-9]*$';

      init.call(this);
    }

    SettingsViewModel.prototype.destroy = function() {};

    SettingsViewModel.prototype.resetAllCashCount = function() {
      this.boxes.forEach(function(box) {
        box.cashCount.value = 0;
      });
    };

    SettingsViewModel.prototype.resetAllCoinsCount = function() {
      this.boxes.forEach(function(box) {
        box.coinsCount.value = 0;
      });
    };

    SettingsViewModel.prototype.resetAllEurokeyCount = function() {
      this.boxes.forEach(function(box) {
        box.euroKeyCount.value = 0;
      });
    };

    SettingsViewModel.prototype.getActuationData = function() {
      var result = {
        deviceSerial: this.deviceSerial,
        data: []
      };

      tryPushActuationData(result.data, this.lightsAuto, fromBool);
      tryPushActuationData(result.data, this.lightsOn, fromBool);
      tryPushActuationData(result.data, this.groupsOn, fromBool);
      tryPushActuationData(result.data, this.groupsAuto, fromBool);
      tryPushActuationData(result.data, this.antifreezeOn, fromBool);
      tryPushActuationData(result.data, this.antifreezeFrom);
      tryPushSpecialActuationData(result.data, this.lightsFrom);
      tryPushSpecialActuationData(result.data, this.lightsTo);
      tryPushActuationData(result.data, this.lightsFromTimeHour);
      tryPushActuationData(result.data, this.lightsFromTimeMinute);
      tryPushActuationData(result.data, this.lightsToTimeHour);
      tryPushActuationData(result.data, this.lightsToTimeMinute);
      tryPushSpecialActuationData(result.data, this.groupsFrom);
      tryPushSpecialActuationData(result.data, this.groupsTo);
      tryPushActuationData(result.data, this.groupsFromTimeHour);
      tryPushActuationData(result.data, this.groupsFromTimeMinute);
      tryPushActuationData(result.data, this.groupsToTimeHour);
      tryPushActuationData(result.data, this.groupsToTimeMinute);
      tryPushActuationData(result.data, this.tariffsFromTimeHour);
      tryPushActuationData(result.data, this.tariffsFromTimeMinute);
      tryPushActuationData(result.data, this.tariffsToTimeHour);
      tryPushActuationData(result.data, this.tariffsToTimeMinute);
      tryPushActuationDataArray(result.data, this.tariffs);
      tryPushActuationData(result.data, this.tariffsOn, fromBool);

      tryPushActuationData(result.data, this.doserWork);
      tryPushActuationData(result.data, this.doserPause);

      tryPushActuationData(result.data, this.reverseOsmosis, fromBool);
      tryPushActuationData(result.data, this.reverseOsmosisAndGroups, fromBool);

      this.boxes.forEach(function(box) {
        tryPushActuationData(this, box.boxState, fromBool);
        tryPushActuationData(this, box.cashCount, fromCurrency);
        tryPushActuationData(this, box.coinsCount, fromCurrency);
        tryPushActuationData(this, box.euroKeyCount, fromCurrency);
      }, result.data);

      tryPushActuationData(result.data, this.doserWork);
      tryPushActuationData(result.data, this.doserPause);
      tryPushActuationData(result.data, this.delay6M1);
      tryPushActuationData(result.data, this.delayBfv);
      tryPushActuationData(result.data, this.delayLps);

      return result;
    };

    SettingsViewModel.prototype.refresh = function(deviceJson, modbus) {
      var facilityPoint;

      this.modbusType = modbus;

      if (deviceJson === null) {
        return;
      }

      facilityPoint = facilityUtils.getFacilityPoint(deviceJson);

      //device refresh
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      // FACILITY
      this.pointId = facilityPoint.id;
      this.name = facilityPoint.name;

      this.lightsAuto = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_RASVJETA_AUTO
      );
      this.lightsOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_RASVJETA_ON
      );
      this.groupsAuto = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_GRUPE_AUTO
      );
      this.groupsOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_GRUPE_ON
      );
      this.antifreezeOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_ANTISMRZ
      );
      this.antifreezeFrom = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_TEMPER_ANTISMRZ
      );
      // TURN ON/OFF REVERSE OSMOSIS
      this.reverseOsmosis = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_REV_OSMOZA
      );
      // TURN ON/OFF GROUPS AND REVERSE OSMOSIS (WHOLE TECHNOLOGY)
      this.reverseOsmosisAndGroups = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_TEHNOLOGIJA
      );
      // FOR ETHERNET AND SERIAL MODBUS TYPE
      if (modbus !== ModBusTypeEnum.ETHERNET_241) {
        this.lightsFrom = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJETA_START
        );
        this.lightsTo = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJETA_STOP
        );
        this.groupsFrom = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_SCHED_GRUPE_START
        );
        this.groupsTo = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_SCHED_GRUPE_STOP
        );
        // ===================================================
        this.lightsFromTimeHour = null;
        this.lightsFromTimeMinute = null;
        this.lightsToTimeHour = null;
        this.lightsToTimeMinute = null;
        this.groupsFromTimeHour = null;
        this.groupsFromTimeMinute = null;
        this.groupsToTimeHour = null;
        this.groupsToTimeMinute = null;
        this.tariffsFromTimeHour = null;
        this.tariffsFromTimeMinute = null;
        this.tariffsToTimeHour = null;
        this.tariffsToTimeMinute = null;
        this.activeTarrif = null;
        this.tariffsOn = null;
      }

      // FOR ETHERNET_241 MODBUS TYPE
      if (modbus === ModBusTypeEnum.ETHERNET_241) {
        this.lightsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_START_HOUR
        );
        this.lightsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_START_MINUTE
        );
        this.lightsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_STOP_HOUR
        );
        this.lightsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_STOP_MINUTE
        );
        this.groupsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_START_HOUR
        );
        this.groupsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_START_MINUTE
        );
        this.groupsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_STOP_HOUR
        );
        this.groupsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_STOP_MINUTE
        );
        this.tariffsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_START_HOUR
        );
        this.tariffsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_START_MINUTE
        );
        this.tariffsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_STOP_HOUR
        );
        this.tariffsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_STOP_MINUTE
        );
        this.activeTarrif = facilityUtils.getFeedValue(
          facilityPoint,
          facilityUtils.FeedReferences.OP_TARIFE_SCHEDULE_ACTIVE_Q
        );
        this.tariffsOn = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_BUTTON_ENABLE
        );
        // ==============================================================
        this.lightsFrom = null;
        this.lightsTo = null;
        this.groupsFrom = null;
        this.groupsTo = null;
      }

      // BOXES
      this.boxes = [];
      washBoxUtils.getWashBoxPoints(facilityPoint).forEach(function(boxJson) {
        this.push({
          name: boxJson.name,
          // serviceHoursCount: {value:123},  //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET),
          cashCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET),
          coinsCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_ZETONI_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_ZETONI_RESET),
          euroKeyCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_KEY_KREDIT_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KEY_KREDIT_RESET)
          boxState: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_BUTTON
          ),
          resetCash: function() {
            this.cashCount.value = 0;
          },
          resetCoins: function() {
            this.coinsCount.value = 0;
          },
          resetEurokey: function() {
            this.euroKeyCount.value = 0;
          }
        });
      }, this.boxes);

      // TARIFFS
      this.tariffs = getTariffObject(
        facilityUtils.getTariffs(facilityPoint)
      ).sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
      });

      // DOSER
      var doserPoint = doserSubsystemUtils.getDoserSubsystemPoint(
        facilityPoint
      );
      this.doserWork = getActuatorObject(
        doserSubsystemUtils.getActuator,
        doserPoint,
        doserSubsystemUtils.ActuatorReferences.OP_PRASAK_VRIJEME_RADA
      );
      this.doserPause = getActuatorObject(
        doserSubsystemUtils.getActuator,
        doserPoint,
        doserSubsystemUtils.ActuatorReferences.OP_PRASAK_VRIJEME_PAUZE
      );

      // REVERSE OSMOSIS
      var roPoint = reverseOsmosisSubsystemUtils.getReverseOsmosisSubsystemPoint(
        facilityPoint
      );
      this.delay6M1 = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_ZADRSKA_CRPKA_OSMOZA
      );
      this.delayBfv = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_ZADRSKA_BFV_OSMOZA
      );
      this.delayLps = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_TON_TLAK_REV_OSM
      );
    };

    function tryPushActuationData(dataArray, actuator, valueFormatterCallback) {
      if (!actuator) {
        return;
      }
      if (actuator.value !== actuator.oldValue) {
        dataArray.push({
          id: actuator.id,
          value: valueFormatterCallback
            ? valueFormatterCallback(actuator.value)
            : actuator.value
        });
      }
    }

    function tryPushSpecialActuationData(
      dataArray,
      actuator,
      valueFormatterCallback
    ) {
      if (!actuator) {
        return;
      }
      var toStringHour = actuator.valueHour.toString();
      var toStringMinute = actuator.valueMinute.toString();
      toStringHour =
        toStringHour.length === 1 ? "0" + toStringHour : toStringHour;
      toStringMinute =
        toStringMinute.length === 1 ? "0" + toStringMinute : toStringMinute;
      actuator.value = toStringHour + toStringMinute;

      if (actuator.value !== actuator.oldValue) {
        dataArray.push({
          id: actuator.id,
          value: valueFormatterCallback
            ? valueFormatterCallback(actuator.value)
            : actuator.value
        });
      }
    }

    function tryPushActuationDataArray(dataArray, actuators) {
      actuators.forEach(function(actuator) {
        if (actuator.value !== actuator.oldValue) {
          dataArray.push({
            id: actuator.id,
            value: actuator.value
          });
        }
      });
    }

    return SettingsViewModel;

    function init() {}

    function getActuatorObject(
      getActuatorCallback,
      pointJson,
      reference,
      formatterCallback
    ) {
      var actuatorJson = getActuatorCallback(pointJson, reference),
        result = {};

      if(!actuatorJson) {
        return;
      }

      result["id"] = actuatorJson.id;
      result["value"] = result[
        "oldValue"
      ] = modelUtils.parseActuatorCurrentValue(
        actuatorJson.value,
        actuatorJson.actuatorType
      );

      return formatterCallback ? formatterCallback(result) : result;
    }

    function getSpecialActuatorObject(
      getActuatorCallback,
      pointJson,
      reference
    ) {
      var actuatorJson = getActuatorCallback(pointJson, reference),
        result = {};

      if(!actuatorJson) {
        return;
      }

      result["id"] = actuatorJson.id;
      result["value"] = result[
        "oldValue"
      ] = modelUtils.parseActuatorCurrentValue(
        actuatorJson.value,
        actuatorJson.actuatorType
      );
      result["valueHour"] = modelUtils.parseActuatorCurrentHourValue(
        actuatorJson.value
      );
      result["valueMinute"] = modelUtils.parseActuatorCurrentMinuteValue(
        actuatorJson.value
      );

      return result;
    }

    function getTariffObject(tariffsList) {
      return tariffsList.reduce(function(newList, tariff) {
        newList.push({
          id: tariff.id,
          name: tariff.reference.charAt(3) + tariff.reference.charAt(4),
          value: parseInt(tariff.value),
          oldValue: parseInt(tariff.value)
        });
        return newList;
      }, []);
    }

    function fromCurrency(value) {
      return value * 10;
    }

    function fromBool(value) {
      return value ? "1" : "0";
    }
  }
})();
